import React from 'react'
import { css } from 'emotion'
import {
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  FacebookIcon,
  TwitterIcon,
  WhatsappIcon,
} from 'react-share';

const main = css({
  label: 'share',
  zIndex: 100,
  position: 'fixed',
  right: 0,
  top: '50%',
  transform: 'translateY(-50%)',

  div: {
    cursor: 'pointer',
    transition: 'all 0.3s ease',

    ':hover': {
      transform: 'scale(1.05)'
    }
  }
});

const notsticky = css({
  label: 'share',
  display: 'flex',
  justifyContent: 'center',

  div: {
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    margin: '0 3px',

    ':hover': {
      transform: 'scale(1.05)'
    }
  }
});

const Share = ({ slug, title, className = '' }) => (
  <div className={className === 'notsticky' ? notsticky : main}>
    <FacebookShareButton url={`https://chicasalfrente.com${slug}`}>
      <FacebookIcon size={42} round={true}/>
    </FacebookShareButton>

    <TwitterShareButton url={`https://chicasalfrente.com${slug}`} via="ChicasAlFrente_" title={title}>
      <TwitterIcon size={42} round={true}/>
    </TwitterShareButton>

    <WhatsappShareButton url={`https://chicasalfrente.com${slug}`} separator=" - " title={title}>
      <WhatsappIcon size={42} round={true}/>
    </WhatsappShareButton>
  </div>
)

export default Share;